import React from "react";
import {
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import {
  SubdirectoryArrowRight as SubdirectoryArrowRightIcon,
} from "@mui/icons-material";

export interface ChildCategoryItemData {
  id: string;
  name: string;
  parent?: string;
  [key: string]: any;
}

interface ChildCategoryItemProps {
  category: ChildCategoryItemData;
  isSelected?: boolean;
  isVisible?: boolean;
  onClick: () => void;
  paddingLeft?: number;
  sx?: any;
  itemSx?: any;
}

const ChildCategoryItem: React.FC<ChildCategoryItemProps> = ({
  category,
  isSelected = false,
  isVisible = true,
  onClick,
  paddingLeft = 4,
  sx,
  itemSx,
}) => {
  return (
    <ListItem
      sx={{
        p: 0,
        mb: 0.5,
        pl: paddingLeft,
        display: isVisible ? "block" : "none",
        ...itemSx,
      }}
    >
      <ListItemButton
        onClick={onClick}
        sx={{
          borderRadius: 1,
          backgroundColor: "transparent",
          color: isSelected ? "primary.main" : "inherit",
          fontWeight: isSelected ? "bold" : "normal",
          pl: 1,
          pr: 1,
          "&:hover": {
            backgroundColor: "action.hover",
          },
          ...sx,
        }}
      >
        <ListItemIcon sx={{ color: "inherit", minWidth: 36 }}>
          <SubdirectoryArrowRightIcon sx={{ fontSize: 20 }} />
        </ListItemIcon>
        <ListItemText primary={category.name} />
      </ListItemButton>
    </ListItem>
  );
};

export default ChildCategoryItem;

